import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { getFileUploadActivity } from '../../ducks/files/filesSelectors';
import { DialogAppBar } from '../DialogAppBar';
import { useMiaSelector } from '../hooks';
import { StickyList, StickyListSubheader } from '../StickyList';
import { ActiveUploadListItem } from './ActiveUploadListItem';
import { CompletedUploadListItem } from './CompletedUploadListItem';
import { FailedUploadListItem } from './FailedUploadListItem';

interface IUploadActivityDialogProps {
  onClose: () => any;
}

const useStyles = makeStyles(
  createStyles({
    noPadding: {
      padding: 0
    }
  })
);

export const UploadActivityDialog = React.memo<IUploadActivityDialogProps>(({ onClose }) => {
  const classes = useStyles();
  const { active, completed, failed } = useMiaSelector(getFileUploadActivity);
  const noItems = React.useMemo<boolean>(() => active.length === 0 && completed.length === 0 && failed.length === 0, [
    active,
    completed,
    failed
  ]);

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogAppBar title="Upload Activity" onCloseClick={onClose} hideButton />
      <DialogContent className={classes.noPadding}>
        <StickyList disablePadding>
          {failed.length > 0 && (
            <StickyListSubheader label="Failed">
              {failed.map(x => (
                <FailedUploadListItem key={x.url} file={x} />
              ))}
            </StickyListSubheader>
          )}
          {active.length > 0 && (
            <StickyListSubheader label="Active">
              {active.map(x => (
                <ActiveUploadListItem key={x.url} file={x} />
              ))}
            </StickyListSubheader>
          )}
          {completed.length > 0 && (
            <StickyListSubheader label="Completed">
              {completed.map(x => (
                <CompletedUploadListItem key={x.url} file={x} />
              ))}
            </StickyListSubheader>
          )}
          {noItems && (
            <ListItem>
              <ListItemText primary="No upload activity." />
            </ListItem>
          )}
        </StickyList>
      </DialogContent>
    </Dialog>
  );
});
